
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('circle',{staticClass:"toStroke",attrs:{"cx":"12","cy":"9.932","r":"8.265","stroke":"#042132","stroke-width":"1.429"}}),_c('path',{staticClass:"toStroke",attrs:{"d":"M16.938 9.904l-7.652 4.631v-9.26l7.652 4.629zm.675-.408h-.002.002zm-8.804 5.891v-.004.004z","stroke":"#042132","stroke-width":"1.429","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{staticClass:"toStroke",attrs:{"d":"M21.524 2.857L2.476 15.238","stroke":"#fff","stroke-width":"1.429","stroke-linecap":"round"}}),_c('path',{staticClass:"toStroke",attrs:{"d":"M21.524 3.81L2.476 16.19","stroke":"#042132","stroke-width":"1.429","stroke-linecap":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M.571 0h22.857v20H.571z"}})])])])
          )
        }
      }
    